import React, { useEffect, useState } from 'react';
import { Button, Typography, Card,Modal,Row,Col,Drawer,Form,Input,DatePicker,Select  } from 'antd';
import dayjs from "dayjs";
import {PlusOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import Fileupload from "../../common/fileupload/fileupload";
import { DocTypes, OwnerType, EntityTypes } from "../../constants/commonConstants";
import * as documentUtility from "../../util/documentThumbUtility";
import { useStore } from "../../store/store";
import moment from 'moment/moment';
import * as supplierService from "../../service/fleet-management/supplierService";
import notification from '../../service/notification';
import { checkIsSTO,checkIsBroker,checkIsCountryPresent } from "../../util/constantUtility";


export default function RequestToFleetOwnerC({openAddDetailsDrawer,onClose,getApprovalPendingfn, supplierDetail,supplierDocs ,supplierDetailfn}) {
  const { t } = useTranslation();
  const [vatForm] = Form.useForm();
  const format = 'DD/MM/YYYY';
  const { user, saveUser } = useStore();
// const [openAddDetailsDrawer, setopenAddDetailsDrawer] = useState(false);
// const [buttonNameChange, setbuttonNameChange] = useState(false);
  const [frontDocs, setFrontDocs] = useState({});
  const[savebtnloader, setsavebtnloader] = useState(false)
  const [kycFormValues, setKycFormValues] = useState({});
 const [changeUserTypeLoader, setchangeUserTypeLoader] = useState(false);
    const [ibanNumber, setIbanNumber] = useState([""]);
  

useEffect(() => {
  console.log(supplierDocs)
  if(supplierDocs){
  const formValues = {
    vatUpload: {
                    fileName: supplierDocs.vatCertificate?.frontDoc?.fileName,
                    fileUrl: supplierDocs.vatCertificate?.frontDoc?.documentPath,
                    fileThumbUrl: supplierDocs.vatCertificate?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                },
    vatExpiry: supplierDocs.vatCertificate?.expiryDate
                    ? moment(supplierDocs.vatCertificate.expiryDate).format(format)
                    : null,
    vatNumber: supplierDocs.vatCertificate?.documentNumber || null,
    tradeLicenseUpload:{
                    fileName: supplierDocs.tradeLicense?.frontDoc?.fileName,
                    fileUrl: supplierDocs.tradeLicense?.frontDoc?.documentPath,
                    fileThumbUrl: supplierDocs.tradeLicense?.frontDoc?.documentPathThumb,
                    isInsertUpdate: false
                },
                tradeLicenseNumber:supplierDocs.tradeLicense?.documentNumber || null,
                tradeExpiry: supplierDocs.tradeLicense?.expiryDate
                ? moment(supplierDocs.tradeLicense.expiryDate).format(format)
                : null,

                  iBanNo: [...(supplierDocs?.iBanNo || [])],
            registrationOffice: supplierDocs?.registrationOffice,
            certification: supplierDocs?.certification?.length > 0 ? supplierDocs?.certification[0] : ""
  }
    vatForm.setFieldsValue(formValues)
    setKycFormValues(formValues)
      // console.log("sss", formValues)
  
}
}, [])

 const isTurkeyKazakhstanPresent = (supplierDetail?.country === "Turkey" ||
                                     supplierDetail?.country === "Kazakhstan" ||
                                     !checkIsCountryPresent(supplierDetail?.country));
  // console.log(vatForm.getFieldsValue())
  const disablePastDates = (current) => {
    return current && current <= dayjs().endOf('day')
  };
  
  const handleFormChange=(field,val)=>{
    vatForm.setFieldValue(field, val);
setKycFormValues((prev) => ({
      ...prev,
      [field]: val,
    }));    
    // console.log(vatForm.getFieldValue(field, val))
  }


  const onFileUploadDocs = (file, fieldName) => {    
    var updatedInquiryDocs = {...frontDocs};
    updatedInquiryDocs = {
      docType: file.DocType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      size: file.size,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.fileData,
    };
        setFrontDocs(updatedInquiryDocs);
        // console.log(updatedInquiryDocs,'front')
         vatForm.setFieldsValue({
      [fieldName]: {
        docType: file.DocType,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        isInsertUpdate: true,
        isPathSet: true,
        size: file.size,
        fileThumbUrl: file.FileThumbURL
      }
    })
  }

    //function to add new field for IBAN number
  const addIbanNumber = () => {
    let temp = [...ibanNumber];
    temp.push("");
    setIbanNumber(temp);
  }

  const handleSumbitForm = async () => {
      setchangeUserTypeLoader(true)

    try {
      const form = await vatForm.validateFields(); 
      const values = vatForm.getFieldsValue();
      setsavebtnloader(true) 
      getApprovalPendingfn(true); 
      let payload = {
        supplierId: supplierDetail ? supplierDetail?.userId : '',
        vatCertificate: {
          documentNumber: values?.vatNumber,
          expiryDate: values?.vatExpiry ? moment(values?.vatExpiry, format).format("YYYY-MM-DD") : null,
          frontDoc: {
            isInsertUpdate: true,
            documentPath: values?.vatUpload?.fileUrl,
            documentPathThumb: values?.vatUpload?.fileThumbUrl,
            fileName: values?.vatUpload?.fileName,
            isPathSet: true,
          },
        },
        tradeLicense: {
          documentNumber: values?.tradeLicenseNumber,
          expiryDate: values?.tradeExpiry ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD") : null,
          frontDoc: {
            isInsertUpdate: values?.tradeLicenseUpload?.isInsertUpdate,
            documentPath: values?.tradeLicenseUpload?.fileUrl,
            documentPathThumb: values?.tradeLicenseUpload?.fileThumbUrl,
            fileName: values?.tradeLicenseUpload?.fileName,
            isPathSet: true,
          },
        },
        ...(isTurkeyKazakhstanPresent && {
                      certification: [values?.certification],
                      iBanNo: ibanNumber,
        
        })   
      };
      const response = await supplierService.addSupplierKyc(payload);
      if(response?.status === 200 ){
        notification.success(t("KYC_DETAIL_KEY"), t("KYC_DETAILS_SUCCESS"));
          setchangeUserTypeLoader(false)
        onClose();
        if(supplierDetail?.userKycStatus === 'Approved'){
        supplierDetailfn()
        }
      }
    } catch (error) {
        setchangeUserTypeLoader(false)
      console.error('Error submitting form:', error);
    }
  };
useEffect(() => {
  if (kycFormValues?.iBanNo?.length) {
    const fields = {};
    kycFormValues.iBanNo.forEach((val, index) => {
      fields[`iBanNo_${index}`] = val;
    });
    vatForm.setFieldsValue(fields);
    setIbanNumber(kycFormValues?.iBanNo)
  }
}, [kycFormValues?.iBanNo]);
  return (
    <div>
      
    <Drawer
  width={500}
  title="Add Details"
  placement="right"
  open={openAddDetailsDrawer} 
  onClose={onClose}
>

  <strong>
   {t("ACCOUNT_VAT_REGISTRATION_CERTIFICATE")}
   </strong><br/> <br/>



<Form form={vatForm}>
<div>
  
   <Form.Item name="vatUpload" className="floating-label-form-item"
                             rules={[
                               { required: true, message: t("ACCOUNT_VAT_UPLOAD_REQUEST_MSG") },
                             ]}>
                             <Fileupload
                               filetype={DocTypes.VAT_FRONT}
                               defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                 vatForm.getFieldValue("vatUpload")?.fileThumbUrl
                               )}
                               defaultFile={vatForm.getFieldValue("vatUpload")?.fileUrl}
                               fileName={vatForm.getFieldValue("vatUpload")?.fileName}
                               entityId=""
                               entityType={EntityTypes.SUPPLIER}
                               accessFile={false}
                               onChange={(value) => {
                                 onFileUploadDocs(value, "vatUpload");
                               }}
                          
                             />
                           </Form.Item>  

                             <Form.Item
                                                     name="vatNumber"
                                                     rules={[
                                                       {
                                                         required: true,
                                                         message: t("ACCOUNT_VAT_REGISTATION_MSG"),
                                                       },
                                                     ]}
                                                     className="floating-label-form-item"
                                                   >
                                                     <Input
                                                       placeholder={t("SIGNUP_KYC_VAT_REG_NUM_PH")}
                                                        value={kycFormValues.vatNumber}
                                                       className="floating-input-basic"
                                                       maxLength={20}
                                                       onChange={(e)=>handleFormChange("vatNumber",e.target.value)}
                                                      //  onChange={(e) =>
                                                      //    handleFormChange("vatNumber", e.target.value)
                                                      //  }
                                                     />
                                                     <span className="floating-label">
                                                       {t("ACCOUNT_KYC_DETAILS_VAT_REGISTRATION_NO")} <b className="mandate-color">*</b>
                                                     </span>
                                                   </Form.Item> 



                                                       <Form.Item
                                                        name="vatExpiry"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: t("ACCOUNT_SELECT_EXP_MSG"),
                                                          },
                                                        ]}
                                                        className="floating-label-form-item"
                                                      >
                                                        <DatePicker
                                                          className="floating-input-basic"
                                                          format={format}
                                                      value={
                                                          kycFormValues?.vatExpiry
                                                            ? dayjs(kycFormValues.vatExpiry, format)
                                                            : null
                                                              }
                                                          style={{ fontSize: "12px" }}
                                                          disabledDate={disablePastDates}
                                                          placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                                         onChange={(date, dateString) =>
                                                           handleFormChange(
                                                             "vatExpiry",
                                                             dateString
                                                           )
                                                         }
                                                        />
                                                        <label className="floating-label">
                                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")} <b className="mandate-color">*</b>
                                                        </label>
                                                      </Form.Item>
</div><br/>
{isTurkeyKazakhstanPresent ? 
<div>
    <strong>{t("FILE_VERIFY_IBAN_CERTIFICATE_NUMBER")}</strong><br/><br/>
                    {ibanNumber?.map((ele, index) => (
  <Form.Item
    key={index}
    name={`iBanNo_${index}`}
    rules={[
      { required: true, message: t("ACCOUNT_ENTER_IBAN_NO") },
      ({ getFieldValue }) => ({
        validator(_, value) {
          const ibanlength =
            supplierDetail?.country === "Kazakhstan"
              ? 20
              : supplierDetail?.country === "Turkey"
              ? 26
              : 34;
          // if (!value) {
          //   return Promise.reject(t("IBAN_REQUIRED"));
          // }
          if (value.length !== ibanlength) {
            return Promise.reject(`${t("IBAN_LENGTH_REQUIRED")} ${ibanlength}`);
          }
          return Promise.resolve();
        },
      }),
    ]}
    className="floating-label-form-item"
  >
    <Input
      value={kycFormValues?.iBanNo?.[index]}
      placeholder={t("IBAN_PLACEHOLDER")}
      className="floating-input"
      maxLength={
        supplierDetail?.country === "Kazakhstan"
          ? 20
          :supplierDetail?.country === "Turkey"
          ? 26
          : 34
      }
      onChange={(e) => {
        const updatedIbanNumbers = [...ibanNumber];
        updatedIbanNumbers[index] = e.target.value;
        setIbanNumber(updatedIbanNumbers);

        const updatedFormValues = [...(kycFormValues?.iBanNo || [])];
        updatedFormValues[index] = e.target.value;
        setKycFormValues({
          ...kycFormValues,
          iBanNo: updatedFormValues,
        });

        vatForm?.setFieldValue(`iBanNo_${index}`, e.target.value);
      }}
    />
    <label className="floating-label">
      {t("ACCOUNT_IBAN_NO")}
      <b className="mandate-color">*</b>
    </label>
  </Form.Item>
))}

                          <Row gutter={16}>
                            <Col span={16}>
                              {/* <label className='registration-lable'>{t("MUST_BE_KEY")} {accountDetails?.country === 'Kazakhstan' ? "20" : accountDetails?.country === 'Turkey' ? "26" : "34"} {t("ACCOUNT_DIGITS")}</label> */}
                            </Col>
                            <Col span={8}>
                              <Button type='secondary'
                                icon={<PlusOutlined />}
                                className="add-doc"
                                onClick={addIbanNumber}
                              >
                                {t("ACCOUNT_ADD_IBAN")}
                              </Button>
                            </Col>
                          </Row>


                               <Form.Item
                              rules={[{ required: true, message: t("ACCOUNT_SELECT_CERTIFICATION_MSG") }]}
                              name="certification"
                              className="floating-label-form-item"
                            >
                              <Select
                                options={[
                                  { label: 'K1', value: 'K1' },
                                  { label: 'C2', value: 'C2' },
                                ]}
                                value={vatForm?.getFieldValue("certification")}
                                onChange={(value) => {
                                  handleFormChange("certification", value);
                                }}
                                style={{ width: "100%", height: "56px" }}
                              />
                              <label className="floating-label">{t("ACCOUNT_CERTIFICATION")}<b className="mandate-color">*</b></label>
                            </Form.Item>
                            </div>
 :
<div>
   <strong>
   {t("ACCOUNT_TRADE_LICENSE")}
   </strong><br/> <br/>
   <Form.Item name="tradeLicenseUpload" className="floating-label-form-item"
                             rules={[
                               { required: true, message: t("TRADE_DOC_UPLOAD_REQUIRED") },
                             ]}>
                             <Fileupload
                               filetype={DocTypes.TRADE_LICENSE_FRONT}
                               defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                 vatForm.getFieldValue("tradeLicenseUpload")?.fileThumbUrl
                               )}
                               defaultFile={vatForm.getFieldValue("tradeLicenseUpload")?.fileUrl}
                               fileName={vatForm.getFieldValue("tradeLicenseUpload")?.fileName}
                               entityId=""
                               entityType={EntityTypes.SUPPLIER}
                               accessFile={false}
                               onChange={(value) => {
                                 onFileUploadDocs(value, "tradeLicenseUpload");
                               }}
                          
                             />
                           </Form.Item>  


                             <Form.Item
                                                     name="tradeLicenseNumber"
                                                     rules={[
                                                       {
                                                         required: true,
                                                         message: t("TRADE_REG_NO_REQUIRED"),
                                                       },
                                                     ]}
                                                     className="floating-label-form-item"
                                                   >
                                                     <Input
                                                       placeholder={t("ACCOUNT_TRADE_REGISTRATION_MSG")}
                                                      value={kycFormValues?.tradeLicenseNumber}
                                                       className="floating-input-basic"
                                                       maxLength={20}
                                                       onChange={(e) =>
                                                         handleFormChange("tradeLicenseNumber", e.target.value)
                                                       }
                                                     />
                                                     <span className="floating-label">
                                                       {t("ACCOUNT_TRADE_REGISTRATION_NO")} <b className="mandate-color">*</b>
                                                     </span>
                                                   </Form.Item> 



                                                       <Form.Item
                                                        name="tradeExpiry"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message: t("ACCOUNT_SELECT_EXP_MSG"),
                                                          },
                                                        ]}
                                                        className="floating-label-form-item"
                                                      >
                                                        <DatePicker
                                                          className="floating-input-basic"
                                                          format={format}
                                                    value={
                                                        kycFormValues?.tradeExpiry
                                                          ? dayjs(kycFormValues.tradeExpiry, format)
                                                          : null
                                                      }
                                                          style={{ fontSize: "12px" }}
                                                          disabledDate={disablePastDates}
                                                          placeholder={t("SIGNUP_KYC_VAT_REG_EXPIRY_PH")}
                                                         onChange={(date, dateString) =>
                                                           handleFormChange(
                                                             "tradeExpiry",
                                                             dateString
                                                           )
                                                         }
                                                        />
                                                        <label className="floating-label">
                                                          {t("ACCOUNT_KYC_DETAILS_EXPIRY_DATE")} <b className="mandate-color">*</b>
                                                        </label>
                                                      </Form.Item>
                                                        </div> 

                                                        }
                                                        <br/>
                                                        <Row>
                                                        <Col span={12}>
                                                        <Button 
                                                        onClick={onClose} 
                                                        style={{width:'100%'}} type='secodary'
                                                        className="cancel-btn" >
                                                            {t("ACCOUNT_CANCEL")}

                                                            </Button>
                                                        </Col>
                                                            <Col span={12}>
                                                            <Button 
                                                            loading={changeUserTypeLoader}
                                                             onClick={handleSumbitForm}
                                                            type='primary'style={{width:'100%'}}
                                                            className="submit-btn">
                                                            {t("ACCOUNT_SAVE_CHANGES")}
                                                            </Button>
                                                            </Col>

                                                        </Row>
                                                        </Form>
                                                        </Drawer>
                                                            </div>
                                                        )
                                                        }
